import constant from "../../constant";
import axios from "axios";
import router from "../../router";
const api = constant.api + "sellers_sales";
// initial state
const state = () => ({
  all: [],
  sellerSales: [],
  items: [],
  sellerSale: {},
});

// getters
const getters = {
  getAll: (state) => {
    return state.all;
  },
  getSellerSale: (state) => {
    return state.sellerSale;
  },

  getSellerSales: (state) => {
    return state.sellerSales;
  },

  getItems: (state) => {
    return state.items;
  },

  totalPriceTTCItems: (state) =>
    state.items.reduce(
      (acc, val) =>
        acc + parseFloat(val.quantity || 0) * parseFloat(val.priceTTC || 0),
      0
    ),

  totalPriceHTItems: (state) =>
    state.items.reduce(
      (acc, val) =>
        acc + parseFloat(val.quantity || 0) * parseFloat(val.priceHT || 0),
      0
    ),

  totalQuantityItems: (state) =>
    state.items.reduce((acc, val) => acc + parseFloat(val.quantity || 0), 0),
  numberItems: (state) => parseFloat(state.items.length),
};

// actions
const actions = {
  async getAll({ commit }) {
    await axios.get(api).then((response) => {
      let sellerSales = response.data;
      commit("setSellerSales", sellerSales);
    });
  },
  async filter({ commit }, data) {
    const payload = {
      startDate: data.startDate || null,
      endDate: data.endDate || null,
      seller_reference: data.seller_reference || null,
      seller_customer_reference: data.seller_customer_reference || null,
    };

    await this.$api
      .create(api + "_filter", payload, { confirm: false })
      .then((response) => {
        commit("setSellerSales", response.data);
      });
  },
  async show({ commit }, reference) {
    await commit("setSellerSale", {});
    await axios.get(api + "/" + reference).then((response) => {
      let sellerSale = response.data;
      commit("setSellerSale", sellerSale);
    });
  },

  async getAllItems({ commit }) {
    await axios.get(api + "_items").then((response) => {
      commit("setItems", response.data);
    });
  },

  async store({ commit, dispatch }, data) {
    await this.$api.create(api, data).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") {
        router.push({
          name: "seller-sales-index",
        });
      }
    });
  },

  async storeItem({ commit, dispatch }, data) {
    await this.$api.create(api + "_items", data).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") {
        commit("setItems", response.data.data);
      }
    });
  },

  async updateItem({ commit, dispatch }, data) {
    await this.$api.update(api + "_items/" + data.id, data).then((response) => {
      let message = response.data.message;
      let status = response.data.status;

      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") {
        commit("setItems", response.data.data);
      }
    });
  },

  async destroyItem({ commit, dispatch }, id) {
    await this.$api.delete(api + "_items/" + id).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") {
        commit("setItems", response.data.data);
      }
    });
  },

  async update({ dispatch }, data) {
    await this.$api
      .update(api + "/" + data.reference, data)
      .then((response) => {
        let message = response.data.message;
        let status = response.data.status;
        dispatch("notification/store", { status, message }, { root: true });
        if (status == "success") {
          router.push({
            name: "seller-sales-details",
            params: {
              reference: data.reference,
            },
          });
        }
      });
  },

  async destroy({ dispatch }, reference) {
    await this.$api.delete(api + "/" + reference).then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") {
        router.push({ name: "seller-sales-index" });
      }
    });
  },
};

// mutations
const mutations = {
  setSellerSales(state, sellerSales) {
    state.all = sellerSales;
    state.sellerSales = sellerSales;
  },
  setSellerSale(state, sellerSale) {
    state.sellerSale = sellerSale;
  },
  setItems(state, items) {
    state.items = items;
  },
  async search(state, value) {
    value = value.charAt(0).toUpperCase() + value.slice(1);
    console.log(value);
    state.sellerSales = state.all.filter(function (sellerSale) {
      return (
        (sellerSale.reference &&
          sellerSale.reference.toUpperCase().indexOf(value.toUpperCase()) >
            -1) ||
        (sellerSale.sellerCustomer &&
          sellerSale.sellerCustomer.fullName &&
          sellerSale.sellerCustomer.fullName
            .toUpperCase()
            .indexOf(value.toUpperCase()) > -1)
      );
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
